import ModalExitButtons from './modal-exit-buttons';

export default ModalExitButtons;
